import { useState } from 'react';

import MasterService from '../../services/master';

export const useCountryStateCity = () => {
  const [isLoadingProvinceList, setIsLoadingProvinceList] =
    useState<boolean>(false);

  const getCountriesList = async () => {
    try {
      const response = await MasterService.getListCountries();

      if (response.data) {
        const countries = response.data.paises.map(
          ({ descripcionPais, codigoPais }) => ({
            label: descripcionPais,
            value: codigoPais,
          })
        );

        return countries;
      }
    } catch (error) {}
  };

  const getProvinceList = async () => {
    try {
      setIsLoadingProvinceList(true);
      const response = await MasterService.getProvinceList();

      if (response.data) {
        const provinceList = response.data.provincias.map(
          ({ codigoProvincia, descripcionProvincia }) => ({
            label: descripcionProvincia,
            value: codigoProvincia,
          })
        );
        return provinceList;
      }
    } catch (error) {
    } finally {
      setIsLoadingProvinceList(false);
    }
  };

  const getLocalitiesPerProvince = async (provinceCode: string) => {
    try {
      const response = await MasterService.getLocalitiesListPerProvince(
        provinceCode
      );

      if (response.data) {
        const listLocalities = response.data.localidadesPorProvincia.map(
          ({ localidad, codigoPostal, sufijoCodigoPostal }) => ({
            label: `${localidad} (${codigoPostal}-${sufijoCodigoPostal})`,
            value: `${sufijoCodigoPostal}${codigoPostal}`,
            suffixCode: sufijoCodigoPostal,
            zipCode: codigoPostal,
          })
        );
        return listLocalities;
      }
    } catch (error) {}
  };

  return {
    isLoadingProvinceList,
    getCountriesList,
    getProvinceList,
    getLocalitiesPerProvince,
  };
};
